import {
  slackPersonalService
} from "../services/api";
import {
  OAuthCallbackPage
} from "./pairing/OAuthCallbackPage";

/** Redirect target of the owner's read-only Slack connection (GET-14181). */
export function SlackPersonalCallbackPage() {
  return (
    <OAuthCallbackPage
      providerName="SlackPersonal"
      displayName="Slack"
      successType="SLACK_PERSONAL_OAUTH_SUCCESS"
      errorType="SLACK_PERSONAL_OAUTH_ERROR"
      spinnerColorClass="border-indigo-600"
      handleCallback={slackPersonalService.handleCallback}
      showSuccessScreen={false}
      popupSuccessCloseDelayMs={1000}
      navigateDelayOnSuccessMs={0}
      supportsDetachedPopup
    />
  );
}
